var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFilecsvV2 = function SvgFilecsvV2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3531 3.50938L7.99063 0.146875C7.89688 0.053125 7.77031 0 7.6375 0H1C0.723437 0 0.5 0.223437 0.5 0.5V13.5C0.5 13.7766 0.723437 14 1 14H11C11.2766 14 11.5 13.7766 11.5 13.5V3.86406C11.5 3.73125 11.4469 3.60313 11.3531 3.50938ZM10.3469 4.09375H7.40625V1.15313L10.3469 4.09375ZM10.375 12.875H1.625V1.125H6.34375V4.5C6.34375 4.67405 6.41289 4.84097 6.53596 4.96404C6.65903 5.08711 6.82595 5.15625 7 5.15625H10.375V12.875Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilecsvV2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filecsv-v2.ee8ae102.svg";
export { ForwardRef as ReactComponent };